import { useState } from 'react';

import { getCustomerPortalLink } from '../api/Subscription';
import { SUBSCRIPTION_REFRESH_KEY } from '../constants/subscription';
import { debugLog } from '../utils/debugLog';

const useManageSubscription = () => {
  const [redirecting, setRedirecting] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

  const onManageSubscription = async () => {
    setRedirecting(true);
    try {
      const customerPortalLink = await getCustomerPortalLink();
      if (customerPortalLink?.customer_portal_url) {
        try {
          window.localStorage.setItem(SUBSCRIPTION_REFRESH_KEY, String(Date.now()));
        } catch (err) {
          debugLog('useManageSubscription', 'Unable to persist subscription refresh flag in localStorage', err);
        }
        window.location.href = customerPortalLink.customer_portal_url;
      } else {
        setErrorMessage('No customer portal URL found.');
        setRedirecting(false);
      }
    } catch (err) {
      console.error(err);
      setErrorMessage(String(err));
      setRedirecting(false);
    }
  };

  return { redirecting, setErrorMessage, errorMessage, onManageSubscription };
};

export default useManageSubscription;
